import * as React from 'react'

import RawFormattedMessage from './RawFormattedMessage'

interface FormActionsProps {
  className?: string
  submit: string
  reset: string | null
}

export const FormActions = (props: FormActionsProps) => (
  <section className={props.className}>
    {props.reset && (
      <button type='reset' data-qa='form-reset'>
        <RawFormattedMessage id={props.reset} />
      </button>
    )}
    <button type='submit' data-qa='form-submit'>
      <RawFormattedMessage id={props.submit} />
    </button>
  </section>
)
